import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CompositionRoot } from '@/app/composition-root';
import { App } from '@/App';
import '@/styles/tailwind.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

createRoot(container).render(
  <React.StrictMode>
    <BrowserRouter>
      <CompositionRoot>
        <App />
      </CompositionRoot>
    </BrowserRouter>
  </React.StrictMode>
);
